import {AnyHash, ModelInterface, Uuid} from "@hidat/huijs-common";
import {ZonedDateTime} from "@js-joda/core";
import {RailsUpdateTrackingResource, ResourceConfig} from "@hidat/huijs-resource";
import {TenantInterface} from "./tenant.interface";
import {UserInterface} from "./user.interface";

export const AppSessionConfig: ResourceConfig =
  new ResourceConfig('AppSession', 'app_sessions', true, false)

export interface AppSessionInterface extends ModelInterface, RailsUpdateTrackingResource{
  id: Uuid | undefined;
  sessionId: Uuid | undefined;
  appCode: string | undefined;
  appToken: string | undefined;
  expiresAt: ZonedDateTime | undefined;

  tenantId: Uuid | undefined;
  userId: Uuid | undefined;

  roles: AnyHash | undefined;
  permissions: AnyHash | undefined;

  _tenant: TenantInterface | undefined;
  _user: UserInterface | undefined;

}
